webpackJsonp([140089201003275],{

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(141);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactRouterBootstrap = __webpack_require__(111);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _components = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavLink = function NavLink(props) {
	  if (!props.test) {
	    // return <Link to={props.url}>{props.text}</Link>;
	    return _react2.default.createElement(
	      _reactRouterBootstrap.LinkContainer,
	      { to: props.url },
	      _react2.default.createElement(
	        _reactBootstrap.Pager.Item,
	        null,
	        props.text
	      )
	    );
	  } else {
	    return _react2.default.createElement(
	      _reactBootstrap.Pager.Item,
	      { disabled: true },
	      props.text
	    );
	  }
	};
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	  console.log(pathContext);
	  var group = pathContext.group,
	      index = pathContext.index,
	      first = pathContext.first,
	      last = pathContext.last,
	      pageCount = pathContext.pageCount;
	
	  var previousUrl = '/' + pathContext.pathPrefix + '/' + (index - 1 == 1 ? "" : (index - 1).toString());
	  var nextUrl = '/' + pathContext.pathPrefix + '/' + (index + 1).toString();
	
	  return _react2.default.createElement(
	    _reactBootstrap.Grid,
	    null,
	    _react2.default.createElement(_components.PageTitle, { title: "\u89E3\u51B3\u65B9\u6848" }),
	    group.map(function (_ref2) {
	      var node = _ref2.node;
	      return _react2.default.createElement(
	        _reactBootstrap.Row,
	        { key: node.id, className: "text-center" },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: "blogUrl", to: node.fields.slug },
	          node.frontmatter.title
	        )
	      );
	    }),
	    _react2.default.createElement(
	      _reactBootstrap.Pager,
	      null,
	      _react2.default.createElement(NavLink, { test: first, url: previousUrl, text: "\u4E0A\u4E00\u9875" }),
	      ' ',
	      _react2.default.createElement(NavLink, { test: last, url: nextUrl, text: "\u4E0B\u4E00\u9875" })
	    )
	  );
	};
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-solution-index-js-086a6a0c99a38fdf4d88.js